module.exports = __webpack_public_path__ + "img/graph_blur.7cfaf6fc.png";